var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"px-4 mt-n3",attrs:{"cols":"12","md":"6"}},[_c('v-row',{attrs:{"dark":"","align":"end"}},[_c('div',{staticClass:"display-1"},[_vm._v("Afsendte")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }